import React, { useState } from 'react';
import * as Styles from './CreateTicketStep2.style';
import { StepLabel } from 'components/step-label/StepLabel';
import RadioButton from 'components/radio-button/RadioButton';
import { Icon } from 'semantic-ui-react';
import FormikErrorMessage from 'components/formik-error-message/FormikErrorMessage';
import { H6 } from 'utils/resuable-css';
import { useTranslation } from 'react-i18next';

const CreateTicketStep2 = ({ formikProp, ticketDepartment, ticketDepName }) => {
  const { t } = useTranslation('');
  const { values, setFieldValue } = formikProp;
  const [isSubDepOpen, setIsSubDeptOpen] = useState(true);
  return (
    <Styles.CreateTicketStep2SC>
      <StepLabel id="ST2" stepCount={'admin/tickets/create.step2_string1'}>
        {t('admin/tickets/create.step2_string2')}
      </StepLabel>
      <Styles.DepartmentSC>
        {ticketDepartment?.ticket_departments.map((val) => {
          const { ticket_department_definitions: departmentList } = ticketDepName || {};
          const department = departmentList?.find((dep) => dep.id === val.id);
          return val.sub.length === 0 ? (
            <Styles.Dept key={val.id} onClick={() => setFieldValue('dept', val.id)}>
              <RadioButton
                id={val.id}
                checkbox={values.dept}
                setCheckedValue={(value) => setFieldValue('dept', value)}
              />
              <H6>{department?.title_en}</H6>
            </Styles.Dept>
          ) : (
            <React.Fragment key={val.id}>
              <Styles.SubDept onClick={() => setIsSubDeptOpen(!isSubDepOpen)}>
                <Icon name={isSubDepOpen ? 'angle down' : 'angle right'} size="large" />
                <H6>{val?.id}</H6>
              </Styles.SubDept>
              {isSubDepOpen &&
                val.sub.map((subDept) => {
                  const subDepartment = departmentList?.find((dep) => dep.id === subDept.id);
                  return (
                    <Styles.Dept subdept key={subDept.id} onClick={() => setFieldValue('dept', subDept.id)}>
                      <RadioButton
                        id={subDept.id}
                        checkbox={values.dept}
                        setCheckedValue={(value) => setFieldValue('dept', value)}
                      />
                      <H6>{subDepartment?.title_en}</H6>
                    </Styles.Dept>
                  );
                })}
            </React.Fragment>
          );
        })}
      </Styles.DepartmentSC>
      <FormikErrorMessage formikProp={formikProp} value="dept" />
    </Styles.CreateTicketStep2SC>
  );
};
export default CreateTicketStep2;
